export default __webpack_public_path__ + "static/media/user.3ab520f9.svg";